import apiClient from './api';
import type { ConfigurationJalon } from '@/types';

/**
 * Ligne de la grille de compatibilite. `type` correspond a une cle du
 * referentiel reel MaterielDeneignement (voir materielService.MATERIEL_TYPES)
 * - pas limite a pony/tracteur : le lien avec le materiel se fait par cette
 * valeur de type, pas par instance (RG-VH-11 porte sur le type de vehicule,
 * pas sur un engin physique precis).
 */
export interface LigneCompatibilite {
  id: number;
  type: string;
  configuration: ConfigurationJalon;
  rang: number;
  autorise: boolean;
}

export const CONFIGURATION_LABELS: Record<ConfigurationJalon, string> = {
  contact_occupe: 'Contact - poste occupe',
  large_occupe: 'Large - poste occupe',
  contact_libre: 'Contact - poste libre',
  large_libre: 'Large - poste libre',
};

export const compatibiliteService = {
  async list(): Promise<LigneCompatibilite[]> {
    const response = await apiClient.get<LigneCompatibilite[]>('/compatibilites');
    return response.data;
  },

  async update(
    lignes: Array<{ type: string; configuration: ConfigurationJalon; rang: number; autorise: boolean }>
  ): Promise<LigneCompatibilite[]> {
    const response = await apiClient.put<LigneCompatibilite[]>('/compatibilites', { lignes });
    return response.data;
  },
};

export default compatibiliteService;
